import React, { useEffect, useState } from 'react';
import { Col, Row } from "react-bootstrap";

import { useAuth0 } from "@auth0/auth0-react";
import PastoralService from 'Lib/API/PastoralApi/index';
import { toastr } from "react-redux-toastr";
import EventsList from "../EventsList/EventsList";
import EventTasks from '../eventTasks/EventTasks';
import Feeds from '../Feeds';



const Dashboard = ({ 
  handelEventDrawer, 
  openNewTaskDrawer, 
  setCallTasksAgain,
  callTasksAgain,
  openMemberEventDrawer,
  setCallFeedsAgain,
  callFeedsAgain,
  selectedEvent,
  callEventsAgain,
  openContactDrawerHandler,
  eventTypes,
  getEventTypesLoading,
}) => {

  return (
    <>
      <Row className="mt-10 pastoral-dashboard">
        <Col xl={4}>
          <EventTasks
            setCallTasksAgain={setCallTasksAgain}
            callTasksAgain={callTasksAgain}
            setCallFeedsAgain={setCallFeedsAgain}
            openMemberEventDrawer={openMemberEventDrawer}
            openContactDrawerHandler={openContactDrawerHandler}
            getEventTypesLoading={getEventTypesLoading}
            eventTypes={eventTypes}

          />
        </Col>
        <Col xl={4}>
          <Feeds openMemberEventDrawer={openMemberEventDrawer}
            callFeedsAgain={callFeedsAgain}
            setCallFeedsAgain={setCallFeedsAgain}
            openContactDrawerHandler={openContactDrawerHandler}
          />
        </Col>
        <Col xl={4}>
          <EventsList handelEventDrawer={handelEventDrawer} selectedEvent={selectedEvent} callEventsAgain={callEventsAgain}
            eventTypes={eventTypes}
            getEventTypesLoading={getEventTypesLoading}
          />
        </Col>
      </Row>
    </>
  )
}

export default Dashboard